import {Component, ContentChild, Input, TemplateRef} from "@angular/core";

@Component({
  selector: "admin-panel-result",
  templateUrl: "./result.component.html",
  styleUrls: ["./result.component.css"]
})
export class AdminPanelResultComponent {

  @Input() title: string = "";
  @Input() border: string = "";
  @Input() customs: string = "";

  @ContentChild("header", { static: true }) headerTemplate!: TemplateRef<any>;
  @ContentChild("body", { static: true }) bodyTemplate!: TemplateRef<any>;

}
